import React from 'react'
import PropTypes from 'prop-types'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {FormattedMessage, useIntl} from 'react-intl'
import {
    Button,
    HStack,
    Image,
    useToast,
    VisuallyHidden
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FacebookSquareIcon, PinterestIcon, SocialTwitterIcon} from '../../components/icons'

export const ShareLinks = ({title, description, image}) => {
    const {formatMessage} = useIntl()
    const toast = useToast()
    const url = window?.location?.href
    const encodedUrl = encodeURIComponent(url)
    const encodedDesc = encodeURIComponent(description)
    const encodedImage = encodeURIComponent(image)

    const shareLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        pinterest: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedDesc}`
    }

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(url)
            toast({
                title: formatMessage({
                    defaultMessage: 'Copied!',
                    id: 'blog_detail.share_links.success_copied'
                }),
                status: 'success',
                duration: 3000,
                isClosable: true
            })
        } catch (err) {
            console.error(err, 'Error while copy link')
        }
    }

    return (
        <HStack spacing={4} wrap="wrap">
            <Button
                as="a"
                variant="link"
                href={shareLinks.pinterest}
                color="gray.800"
                target="_blank"
                rel="noopener noreferrer"
                leftIcon={<PinterestIcon />}
                title={title}
                aria-label={formatMessage({
                    defaultMessage: 'Share on Pinterest',
                    id: 'blog_detail.share_links.share_on_pinterest'
                })}
            >
                <VisuallyHidden>
                    <FormattedMessage
                        defaultMessage="Share on Pinterest"
                        id="blog_detail.share_links.share_on_pinterest"
                    />
                </VisuallyHidden>
            </Button>
            <Button
                as="a"
                variant="link"
                color="gray.800"
                href={shareLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                leftIcon={<FacebookSquareIcon />}
                title={title}
                aria-label={formatMessage({
                    defaultMessage: 'Share on Facebook',
                    id: 'blog_detail.share_links.share_on_facebook'
                })}
            >
                <VisuallyHidden>
                    <FormattedMessage
                        defaultMessage="Share on Facebook"
                        id="blog_detail.share_links.share_on_facebook"
                    />
                </VisuallyHidden>
            </Button>
            <Button
                onClick={handleCopyLink}
                color="gray.800"
                variant="link"
                leftIcon={
                    <Image src={getAssetUrl('static/img/global/link.png')} className="link-img" />
                }
                title={title}
                aria-label={formatMessage({
                    defaultMessage: 'Copy link to clipboard',
                    id: 'blog_detail.share_links.copy_to_clipboard'
                })}
            >
                <VisuallyHidden>
                    <FormattedMessage
                        defaultMessage="Copy link to clipboard"
                        id="blog_detail.share_links.copy_to_clipboard"
                    />
                </VisuallyHidden>
            </Button>
        </HStack>
    )
}

ShareLinks.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string
}
